import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/input/filled";
import "@olmokit/core/forms/select/filled";
import "@olmokit/core/forms/textarea/filled";
import olmoforms from "@olmokit/core/olmoforms/feedback";

import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: Newsletter
 */
export function Newsletter() {
  console.log("Newsletter mounted.");

  const newsletter = olmoforms(".FormNewsletter:", {
    sent: (formData) => {
      dataLayer.push({
        ...formData,
        event: "form sent",
        form: "Form Newsletter",
      });
    },
  });

  return {
    destroy() {
      newsletter.destroy();
    },
  };
}
